import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Stack,
  Grid,
  Snackbar,
  Alert
} from '@mui/material';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { vendorApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import ApprovePriceUpdateByTeam from '../legalteam/ApprovePriceUpdateByTeam';
import ApprovePriceUpdateByAdmin from './ApprovePriceUpdateByAdmin';
import { useSelector } from 'react-redux';

const ApproveMarketUpdate = () => {
  const role=useSelector((state)=>state.user.role);
  const location = useLocation();
  const { marketData } = location.state || {};
  const navigate = useNavigate();
  const [status, setStatus] = useState('Pending');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleSave = async () => {
    const fd = new FormData();
    fd.append("id", marketData.id);
    fd.append("status", status);

    try {
      const response = await vendorApi.ApprovePriceUpdate(fd);
      setSnackbar({
        open: true,
        message: 'Status updated successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: 'Failed to update status.',
        severity: 'error',
      });
    }
  };

  const handleCancel = () => {
    setStatus(marketData.status);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

 const handleViewProject = () => {
    if (marketData?.projectId) {
      navigate(`/viewProject/viewProject?projectId=${marketData.projectId}`, {
        state: {
          ProjectId: marketData.projectId,
        },
      });
    }
  };

  const handleViewProperty =()=>{
     navigate(`/property/viewProperty?propertyId=${marketData.id}`,{
      state:{
        PropertyId:marketData.id
      }
     })
  }

  return (
    <>
      <Card sx={{ maxWidth: "100%", margin: 'auto', mt: 5, p: 3 }}>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Property Details
          </Typography>
 
         <Grid item xs={12}>
  <Box 
    sx={{
      p: 3, 
      borderRadius: 2, 
      boxShadow: 3, 
      backgroundColor: "white", 
      marginBottom: 5, 
      position: "relative", // Make sure the parent Box has relative positioning
    }}
  >
    <Typography
      variant="h5"
      sx={{ color: "#1976d2", fontWeight: "bold", mb: 2 }}
    >
      {marketData.propertyName}
    </Typography>

   <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
  <Box sx={{ display: "flex", alignItems: "flex-start" }}>
    <LocationOnIcon 
      sx={{ color: "black", mr: 2, mt: 0.5, fontSize: "2rem" }} 
    />
    <Box>
      <Typography variant="body1">{marketData.address}</Typography>
      <Typography variant="body1">{marketData.city}</Typography>
    </Box>
  </Box>

  <Box>
    <Typography>Previous Sqft Price: ₹{marketData.Previousprice}</Typography>
    <Typography>Updated Price: ₹{marketData.sqftPrice}</Typography>
  </Box>
</Box>


    {marketData?.projectId ? (
      <Button
        variant="outlined"
        sx={{
          position: "absolute", 
          top: 10,
          right: 10,
          backgroundColor: "#1976d2",
          color: "white",
        }}
        onClick={handleViewProject}
      >
        View Project Details
      </Button>
    ):(
       <Button
        variant="outlined"
        sx={{
          position: "absolute", 
          top: 10,
          right: 10,
          backgroundColor: "#1976d2",
          color: "white",
        }}
        onClick={handleViewProperty}
      >
        View Property Details
      </Button>
    )}
  </Box>
</Grid>


         
            <Typography variant="subtitle1" gutterBottom>
              Update SqFtPrice
            </Typography>
           { role=='legalteam' ?
        
         <ApprovePriceUpdateByTeam/> : <ApprovePriceUpdateByAdmin/>
}
           
        </CardContent>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ApproveMarketUpdate;
